import React from 'react';
import { Card, Col, Image, Row, Form } from 'react-bootstrap';

class CartItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            Id: 0,
            Name: '',
            Price: '',
            Image: 'kursas1.jpg',
            Quantity: 1,
        };

        this.handleQuantityChange = this.handleQuantityChange.bind(this);
        this.removeItem = this.removeItem.bind(this);
    }

    componentDidMount() {
        this.setState({ Id: this.props.Id });
        this.setState({ Name: this.props.Name });
        this.setState({ Price: this.props.Price });
        if (this.props.Image) this.setState({ Image: this.props.Image });
        if (this.props.Quantity) this.setState({ Quantity: this.props.Quantity });
    }

    handleQuantityChange = (event) => {
        if(event.target.value > 0) {
            console.log(this.state.Id);
            this.props.updateCartTotal(this.state.Id, event.target.value);
            this.setState({ Quantity: event.target.value });
        }else{
            this.props.removeItemFromCart(this.state.Id);
        }
    }

    removeItem = (event) => {
        event.preventDefault();
        this.props.removeItemFromCart(this.state.Id);
    }
            

    render() {

        const cardImgStyle = {
            borderRadius: '10px',
            height: '70px',
        }

        return (

            <Card className='cart-item-card'>
                <Card.Body>
                    <Row>
                        <Col className='md-1'>
                            <Image src={this.state.Image} style={cardImgStyle} />
                        </Col>
                        <Col className='md-2'>
                            <h3>{this.state.Name}</h3>
                        </Col>
                        <Col className='md-2'>
                            <h4>{this.state.Price} €</h4>
                        </Col>
                        <Col className='md-2'>
                            <Form.Control type="number" value={this.state.Quantity} onChange={this.handleQuantityChange} />
                        </Col>
                        <Col className='md-2'>
                            <h4>{this.state.Price * this.state.Quantity} €</h4>
                        </Col>
                        <Col className='md-2'>
                            <button className='btn btn-outline-danger' onClick={this.removeItem}>Ištrinti</button>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        );
    }
}

export default CartItem;
